<template>
  <div class="custom-input" ref="inputField">
    <label class="input-label" v-if="$validate.DataValid(label)">{{ $t(label) }}</label>
    <v-menu ref="colorPickerMenu" v-model="colorPickerOpen" offset-y :disabled="disabled">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          persistent-placeholder
          :value="$validate.DataValid(selectedColor) ? 'Aa' : ''"
          v-bind="attrs"
          v-on="on"
          readonly
          outlined
          single-line
          :rules="[v => (required ? $validate.required(v) || $t('message.formRequired') : true)]"
          :placeholder="$t(placeholder)"
          dense
          :background-color="$validate.DataValid(selectedColor) ? selectedColor : '#ffffff'"
          :class="_isLight(selectedColor) ? 'colorBlack--text' : 'colorWhite--text'"
          @click:clear="updateValueOnChange('')"
          :clearable="enableClear"
        >
          <template v-slot:append>
            <v-icon
              class="fi fi-rr-angle-small-down mt-1"
              size="18"
              :color="
                $validate.DataValid(selectedColor)
                  ? _isLight(selectedColor)
                    ? 'colorBlack'
                    : 'colorWhite'
                  : 'rgba(94, 86, 105, 0.68)'
              "
            ></v-icon>
          </template>
        </v-text-field>
      </template>
      <v-list class="pa-0 color-list">
        <v-list-item
          v-for="(item, i) in colorOptions"
          :key="i"
          :value="item"
          @click="updateValueOnChange(item)"
          :style="{ background: item }"
          :class="_isLight(item) ? 'colorBlack--text' : 'colorWhite--text'"
          >Aa</v-list-item
        >
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import FormSelect from '@/components/formField/FormSelect.vue'

export default {
  name: 'CourseColorPicker',
  components: {
    FormSelect,
  },
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    fieldValue: {
      type: String,
      required: true,
      default: '',
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    enableClear: {
      type: Boolean,
      required: false,
      default: false,
    },
    dispatchUpdateOnChange: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    fieldValue: {
      handler(val) {
        this.selectedColor = val
      },
      immediate: true,
    },
  },
  computed: {
    colorOptions() {
      return [...this.darkColorOptions, ...this.lightColorOptions]
    },
  },
  data: () => ({
    colorPickerOpen: false,
    selectedColor: '',
    darkColorOptions: [
      '#525353',
      '#1B718A',
      '#E25D0A',
      '#CB7500',
      '#0A0ABC',
      '#03B1B1',
      '#A80B9C',
      '#50B71A',
      '#08C995',
    ],
    lightColorOptions: ['#A7FF00', '#2ED8F7'],
  }),
  methods: {
    updateValueOnChange(val) {
      this.selectedColor = val
      if (this.dispatchUpdateOnChange === true) {
        this.$store.dispatch('setDataIsUpdated', true)
      }
      this.$emit('update:fieldValue', val)
    },
    _isLight(color) {
      return this.lightColorOptions.includes(color)
    },
  },
  created() {
    if (this.isAppMode(['T40'])) {
      this.lightColorOptions = [
        ...this.lightColorOptions,
        '#FADADD',
        '#F8C8DC',
        '#FFD6C9',
        '#FFE5B4',
        '#FFF4B8',
        '#FFF0C1',
        '#E2F7E1',
        '#DFF5E1',
        '#C7F0E9',
        '#D9F3F0',
        '#D6E8FF',
        '#CFE7F5',
        '#DDE7FF',
        '#E6D9FF',
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-text-field input {
  color: inherit !important;
}

::v-deep .v-input.error--text {
  color: var(--v-error-base) !important;
  caret-color: var(--v-error-base) !important;
}

.color-list {
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
